import { render, staticRenderFns } from "./FormExamine.vue?vue&type=template&id=a2181cb6&scoped=true&"
import script from "./FormExamine.vue?vue&type=script&lang=js&"
export * from "./FormExamine.vue?vue&type=script&lang=js&"
import style0 from "./FormExamine.vue?vue&type=style&index=0&id=a2181cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2181cb6",
  null
  
)

export default component.exports